export default __webpack_public_path__ + "resources/icons/n131-9011.png";